import { useContext, useEffect } from "react";
import DashboardCardTable from "../Table";
import { CoreContext } from "context/CoreContext";
import moment from "moment";
import CheckIcon from "@mui/icons-material/Check";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardCardWrapper from "../Wrapper";
import {
  LoadingContainer,
  NoDataContainer,
  NoDataIcon,
  NoDataText,
} from "../styled";
import { StyledCardContainer, TableWrapper } from "./styled";

export default function DashboardCardLastSignature({
  register,
  loading,
  filterMonth,
}) {
  const { searchExpression } = useContext(CoreContext);

  const rows =
    register?.holeriteSignatures
      ?.filter((hol) => {
        if (filterMonth) {
          const signatureMonth = moment(hol.signedAt).month() + 1;
          return hol.isSigned && signatureMonth === parseInt(filterMonth);
        }
        return hol.isSigned;
      })
      .sort(
        (a, b) => moment(b.signedAt).valueOf() - moment(a.signedAt).valueOf()
      ) // ordena do mais recente para o mais antigo
      .slice(0, 5) // pega apenas os 3 mais recentes
      .map((hol) => ({
        name: hol.name,
        isSigned: <CheckIcon style={{ color: "green" }} />,
        signedAt: moment(hol.signedAt).format("DD/MM/YYYY HH:mm"),
      })) || [];

  console.log("Assinaturas encontradas:", register?.holeriteSignatures?.length);
  console.log("Assinaturas após filtro:", rows.length);

  const columns = [
    { title: "Nome do funcionário", ref: "name" },
    { title: "Assinado", ref: "isSigned" },
    { title: "Data e Hora da Assinatura", ref: "signedAt" },
  ];

  // Verificar se tem dados após a filtragem
  const hasData = rows.length > 0;

  useEffect(() => {
    console.log("Debug assinaturas:", {
      total: register?.holeriteSignatures?.length,
      assinados: register?.holeriteSignatures?.filter((h) => h.isSigned)
        ?.length,
      filtroMes: filterMonth,
      aposFiltroMes: register?.holeriteSignatures?.filter((h) => {
        const signatureMonth = moment(h.signedAt).month() + 1;
        return (
          h.isSigned &&
          (!filterMonth || signatureMonth === parseInt(filterMonth))
        );
      })?.length,
    });
  }, [register?.holeriteSignatures, filterMonth]);

  if (loading) {
    return (
      <StyledCardContainer>
        <TableWrapper>
          <DashboardCardTable
            title="Assinaturas"
            rows={rows}
            columns={columns}
            searchExpression={searchExpression}
          />
        </TableWrapper>
      </StyledCardContainer>
    );
  }

  if (!hasData) {
    return (
      <StyledCardContainer>
        <DashboardCardWrapper title="Assinaturas">
          <NoDataContainer>
            <NoDataIcon>
              <InsertChartIcon />
            </NoDataIcon>
            <NoDataText>Nenhum registro encontrado</NoDataText>
          </NoDataContainer>
        </DashboardCardWrapper>
      </StyledCardContainer>
    );
  }

  return (
    <StyledCardContainer>
      <DashboardCardTable
        title="Assinaturas"
        rows={rows}
        columns={columns}
        searchExpression={searchExpression}
      />
    </StyledCardContainer>
  );
}
